'use client';

import { c as _c } from "react/compiler-runtime";
import { getApiErrorMessage, useApi } from '@repo/api';
import { useAppForm } from '@repo/form';
import { useMutation } from '@repo/tanstack/query';
import { Button, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, FieldGroup, Spinner, toast } from '@repo/ui/components';
import { changePasswordSchema } from '@/app/@public/_components/change-password-form/schema.ts';

/** Lets the signed-in user set a new password for their own account. */
export const ChangePasswordDialog = t0 => {
  const $ = _c(16);
  const {
    onOpenChange,
    open,
    userId
  } = t0;
  const api = useApi();
  let t1;
  if ($[0] !== api.users.updatePassword || $[1] !== onOpenChange || $[2] !== userId) {
    let t2;
    if ($[4] !== onOpenChange) {
      t2 = () => {
        toast.success("Password changed");
        onOpenChange(false);
      };
      $[4] = onOpenChange;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = api.users.updatePassword.mutationOptions({
      path: {
        id: userId
      }
    }, {
      onError: _temp,
      onSuccess: t2
    });
    $[0] = api.users.updatePassword;
    $[1] = onOpenChange;
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    isPending,
    mutate
  } = useMutation(t1);
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="change-password-dialog.tsx"><DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="change-password-dialog.tsx">Change password</DialogTitle><DialogDescription data-sentry-element="DialogDescription" data-sentry-source-file="change-password-dialog.tsx">Choose a new password for your account.</DialogDescription></DialogHeader>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== mutate) {
    t3 = t4 => {
      const {
        password,
        passwordConfirmation
      } = t4;
      return mutate({
        password,
        password_confirmation: passwordConfirmation
      });
    };
    $[7] = mutate;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isPending || $[10] !== t3) {
    t4 = <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="change-password-dialog.tsx">{t2}<ChangePasswordForm isPending={isPending} onSubmit={t3} data-sentry-element="ChangePasswordForm" data-sentry-source-file="change-password-dialog.tsx" /></DialogContent>;
    $[9] = isPending;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onOpenChange || $[13] !== open || $[14] !== t4) {
    t5 = <Dialog onOpenChange={onOpenChange} open={open} data-sentry-element="Dialog" data-sentry-component="ChangePasswordDialog" data-sentry-source-file="change-password-dialog.tsx">{t4}</Dialog>;
    $[12] = onOpenChange;
    $[13] = open;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
const ChangePasswordForm = t0 => {
  const $ = _c(23);
  const {
    isPending,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      password: "",
      passwordConfirmation: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSubmit) {
    t2 = t3 => {
      const {
        value
      } = t3;
      return onSubmit(value);
    };
    $[1] = onSubmit;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      onChange: changePasswordSchema
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = {
      defaultValues: t1,
      onSubmit: t2,
      validators: t3
    };
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const form = useAppForm(t4);
  let t5;
  if ($[6] !== form) {
    t5 = async event => {
      event.preventDefault();
      await form.handleSubmit();
    };
    $[6] = form;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== form.AppField) {
    t6 = <FieldGroup data-sentry-element="FieldGroup" data-sentry-source-file="change-password-dialog.tsx"><form.AppField children={_temp2} name="password" data-sentry-element="form.AppField" data-sentry-source-file="change-password-dialog.tsx" /><form.AppField children={_temp3} name="passwordConfirmation" data-sentry-element="form.AppField" data-sentry-source-file="change-password-dialog.tsx" /></FieldGroup>;
    $[8] = form.AppField;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DialogClose render={<Button variant="outline" />} data-sentry-element="DialogClose" data-sentry-source-file="change-password-dialog.tsx">Cancel</DialogClose>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isPending) {
    t8 = isPending && <Spinner />;
    $[11] = isPending;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isPending || $[14] !== t8) {
    t9 = <DialogFooter data-sentry-element="DialogFooter" data-sentry-source-file="change-password-dialog.tsx">{t7}<Button disabled={isPending} type="submit" data-sentry-element="Button" data-sentry-source-file="change-password-dialog.tsx">Change password {t8}</Button></DialogFooter>;
    $[13] = isPending;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t9) {
    t10 = <form className="grid gap-4" onSubmit={t5}>{t6}{t9}</form>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== form.AppForm || $[21] !== t10) {
    t11 = <form.AppForm data-sentry-element="form.AppForm" data-sentry-component="ChangePasswordForm" data-sentry-source-file="change-password-dialog.tsx">{t10}</form.AppForm>;
    $[20] = form.AppForm;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp(error) {
  toast.error(getApiErrorMessage(error, "Could not change your password.")[0]?.message);
}
function _temp2(field) {
  return <field.PasswordInput autoComplete="new-password" label="New password" />;
}
function _temp3(field_0) {
  return <field_0.PasswordInput autoComplete="new-password" label="Confirm new password" />;
}